import { connect } from 'react-redux';
import Option from './Option';
import { getTagForId } from '../../reducers'

const mapStateToProps = (state, ownProps) => {
  const { tag: tagId } = ownProps;
  const { tags } = state;

  const tag = getTagForId(tags, tagId);

  return {
    ...ownProps,
    ...tag,
  };
};

const OptionConnector = connect(
  mapStateToProps,
)(Option);

export default OptionConnector;



// WEBPACK FOOTER //
// ./src/components/option/OptionConnector.js